import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  authService = inject(AuthService);

  email = '';
  message = signal('');
  isError = signal(false);

  socials = [
    {
      icon: 'fa-brands fa-facebook-f',
      link: 'https://www.facebook.com/tuconsultorioempresarial',
    },
    {
      icon: 'fa-brands fa-instagram',
      link: 'https://www.instagram.com/tuconsultorioempresarial/',
    },
    {
      icon: 'fab fa-youtube',
      link: 'https://www.youtube.com/channel/UCUVyWIRRrYeqCIXcUXY9bVw/videos',
    },
    {
      icon: 'fa-brands fa-linkedin-in',
      link: 'https://www.linkedin.com/company/tuconsultorioempresarial/',
    },
    {
      icon: 'fa-brands fa-whatsapp',
      link: 'https://wa.me/59162584781',
    },
    {
      icon: 'fa-brands fa-tiktok',
      link: 'https://www.tiktok.com/@tuconsultorioempresarial',
    },
  ];

  async onSubmit() {
    if (!this.email) {
      return;
    }
    this.isError.set(false);
    this.message.set('');

    try {
      const result: any = await this.authService.createNewsLettersApi(this.email);
      this.message.set(result.message);
      this.email = '';
    } catch (ex: any) {
      console.error(ex);
      this.isError.set(true);
      this.message.set(ex.error.message);
    } finally {
      setTimeout(() => {
        this.message.set('');
        this.isError.set(false);
      }, 5000); 
    }
  }
}
